// extracted by mini-css-extract-plugin
export default {"root":"styles_root__zgmrB","block":"styles_block__ZUuuX","slide0":"styles_slide0__15kDL","header":"styles_header__v-m9l"};